import { render, staticRenderFns } from "./ExtratoPedido.vue?vue&type=template&id=b99cc396"
import script from "../controllers/ExtratoPedido.ts?vue&type=script&lang=ts&external"
export * from "../controllers/ExtratoPedido.ts?vue&type=script&lang=ts&external"
import style0 from "./ExtratoPedido.vue?vue&type=style&index=0&id=b99cc396&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports